// Redeem Modal
import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

// import Close from "./Close";
import ScannerImage from "../../assets/img/scanner.png";

import { Modal } from "../Modal";
import Icon from "../Icons";
import Image from "../Image";
import Button from "../Button";
import uiConfig from "../../uiConfig";
import { arabicContent } from "../../constants/index";
import Lottie from "react-lottie";
import config from "../../service/config";
import * as animationData from "../../assets/lottieImages/redeem-loader.json";
import { useEffect, useRef, useState } from "react";

const lang = localStorage.getItem("language");

const RedeemModal = ({
  size,
  isModalOpen,
  hide,
  item,
  baseURL,
  onRedeemInteraction,
  merchantName,
  merchantItem,
  redeem
}) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData.default,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  };

  const alertTextBrand =
    config.clientName === "HDFC" ? "SmartBuy" : "Smartdeals";
  const redirectSite = (type) => {
    hide();
    document.documentElement.style.overflowY = "hidden";
    document.body.style.overflowY = "hidden";
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-alert">
            {type === "online" ? 
            <h4 className="text-center">
              {lang === "AR"
                ? arabicContent.redirectMsg
                : `By clicking on 'Proceed' you are  providing  consent to  be redirected to the merchant's website and ${alertTextBrand} holds no responsibility for any inconveniences or issues incurred hereafter`}
              </h4>:
              <h4 className="text-center">
                {'Please visit the store and use your HDFC bank credit card to avail the offer'}
                </h4>
              }
            <div className="custom-alert-button-group">
              {type === "online" ?
              <>
              <button
                onClick={() => {
                  onRedeemInteraction();
                  window.open(
                    !item.url ? `${baseURL}` : `${item.url}`,
                    "_blank"
                  );
                  document.documentElement.style.overflowY = "auto";
                  document.body.style.overflowY = "auto";
                  onClose();
                }}
              >
                {lang === "AR" ? arabicContent.proceed : `Proceed`}
              </button>
              <button
                onClick={() => {
                  document.documentElement.style.overflowY = "auto";
                  document.body.style.overflowY = "auto";
                  onClose();
                }}
              >
                {lang === "AR" ? arabicContent.cancel : `Cancel`}
              </button>
              </> :
              <button
              onClick={() => {
                document.documentElement.style.overflowY = "auto";
                document.body.style.overflowY = "auto";
                onClose();
              }}>Close</button>}
            </div>
          </div>
        );
      }
    });
  };
  const redeemCoderef = useRef(null);
  var [copytext, setCopy] = useState(false);

  useEffect(() => {
    if (item.isOnline) {
      const cb = navigator.clipboard;
      const paragraph = redeemCoderef.current;
      cb.writeText(paragraph.innerText);
      if (item.redemptionCode) {
        setCopy(true);
        setTimeout(() => setCopy(false), 4000);
      }
    }
  }, copytext);

  let redeemBtnText =
    item?.isOnline === true
      ? item?.offerType === "online coupon"
        ? "Redeem Your Code"
        : item?.offerType === "cashback"
        ? "Redeem Now"
        : item?.offerType === "discount"
        ? "Redeem Now"
        : item?.offerType === "offline coupon"
        ? "Avail Now"
        : item?.offerType === "card linked"
        ? "Avail Now"
        : "Avail Now"
      : "Avail Now";

  let descriptionText =
    item?.isOnline === true
      ? item?.offerType === "cashback"
        ? "cashback"
        : item?.offerType === "discount"
        ? "discount"
        : "offer"
      : "offer";

  return (
    <Modal size={size} isOpen={isModalOpen} hide={hide} redeem={redeem}>
      <Modal.Content >
        <div className="redeem-modal">
          <div className="col-md-12 p-0 header">
            <div className="image">
              <div className="lottie-wrap">
                <Lottie options={defaultOptions} height={530} width={460} />
              </div>
              <div
                className="pull-right h-pointer flex-center abs-close"
                onClick={hide}
              >
                <Icon name="cancel" fill="#000" width={10} height={10} />
              </div>
              <div className="col-md-12 p-0 flex-center content-details">
                <div className="content-div text-center ">
                  <div
                    className="content-header"
                    style={{
                      color:
                        uiConfig.config.whitelabel.merchant_details.redeem_modal
                          .headColor
                    }}
                  >
                    {lang === "AR" ? arabicContent.hooray : `Hooray!`}
                  </div>
                  <div
                    className="content-info mt-18"
                    style={{
                      color:
                        uiConfig.config.whitelabel.merchant_details.redeem_modal
                          .capColor
                    }}
                  >
                    {item.isOnline
                      ? lang === "AR"
                        ? arabicContent.redeemMsg1
                        : item.offerType === "online coupon"
                        ? `Your code for `
                        : `Your ${descriptionText} for `
                      : lang === "AR"
                      ? arabicContent.redeemMsg1
                      : `Your ${descriptionText} for `}
                    <b className="mainName">
                      {config.clientName === "ADIB"
                        ? merchantName
                        : merchantName}
                    </b>
                    {/* <span style={{color:uiConfig.config.whitelabel.merchant_details.redeem_modal.headColor}}>{config.clientName === "ADIB" ? merchantName : item.name}</span> */}
                    {item.isOnline
                      ? lang === "AR"
                        ? arabicContent.redeemMsg3
                        : ` has been activated!`
                      : lang === "AR"
                      ? arabicContent.hasactivated
                      : ` has been activated!`}
                  </div>
                  <div className="mt-28 mt-22">
                    {/* {
            merchantItem.curatedImage ? 
            <img src={merchantItem.curatedImage} style={{margin:"10px",maxHeight: "160px",maxWidth: "100%"}} loading="eager"/>
            :
            <img src={"https://logo.clearbit.com/"+merchantItem.url+"?size=800"}  style={{margin:"10px",maxHeight: "160px",maxWidth: "100%"}} onError={(e)=>{if(merchantItem.image){e.target.onerror = null; e.target.src=merchantItem.image.replace(/ /g, "%20")}}} loading="eager"/>
          } */}
                    <div
                      className="card-image-redeem"
                      style={{
                        // backgroundColor: merchantItem.dominantColorCode
                        //   ? merchantItem.dominantColorCode
                        //   : "#ffffff",
                        backgroundImage: `url("${config.optimoleURL}/w:320/h:200/q:85/rs:fit/${
                          merchantItem?.curatedImage
                            ? merchantItem?.curatedImage
                            : merchantItem?.image
                        }")`
                      }}
                    >
                      {" "}
                    </div>
                    {/* <Image src={merchantImage} w={206} h={160} /> */}
                  </div>
                  {item.redemptionCode && (
                    <div className="col-md-12 dashed-line" />
                  )}
                  <>
                    <div
                      className="content-code"
                      style={{
                        color:
                          uiConfig.config.whitelabel.merchant_details
                            .redeem_modal.codeTextColor
                      }}
                    >
                      {lang === "AR"
                        ? item.redemptionCode
                          ? arabicContent.code
                          : arabicContent.activated
                        : item.redemptionCode
                        ? `Code`
                        : ``}
                    </div>
                    <div
                      className="mt-4 content-redeem-code code-tooltip"
                      ref={redeemCoderef}
                      style={{
                        color:
                          uiConfig.config.whitelabel.merchant_details
                            .redeem_modal.codeColor
                      }}
                    >
                      {item.redemptionCode}
                      {copytext && item.redemptionCode && (
                        <span class="tooltiptext">Code Copied</span>
                      )}
                    </div>
                    <div
                      className="mt-18 content-desc"
                      style={{
                        color:
                          uiConfig.config.whitelabel.merchant_details
                            .redeem_modal?.codeTextColor
                      }}
                    >
                      {lang === "AR"
                        ? item.redemptionCode
                          ? arabicContent.redeemCodeDesc1
                          : arabicContent.redeemCodeDesc2
                        : item.redemptionCode &&
                          item.offerType === "online coupon"
                        ? `After redeeming, your code will be valid for the next 7 days.`
                        : ``}
                    </div>
                    <div className="col-md-12 p-0 content-footer">
                      <div
                        className={
                          config.clientName === "ADIB"
                            ? "redeem-button adb"
                            : "redeem-button"
                        }
                        style={
                          uiConfig.config.whitelabel.merchant_details
                            .redeem_modal.redeem_button
                        }
                        onClick={() => redirectSite(item.isOnline ? "online": "instore")}
                      >
                        {lang === "AR"
                          ? item.redemptionCode
                            ? arabicContent.redeemYourCode
                            : arabicContent.redeemNow
                          : item.redemptionCode
                          ? redeemBtnText
                          : redeemBtnText}
                      </div>
                      {/* <div className="col-md-2">
                      <Image src={ScannerImage} w={56} h={56} alt="scanner" />
                    </div> */}
                    </div>
                    {/* <div className="mt-1 col-md-12 content-desc text-left">
                      {lang === 'AR' ? arabicContent.emiOpt : `Emi option is also applicable for this offer`}
                  </div> */}
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default RedeemModal;
